import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
// SPDX-FileCopyrightText: 2024 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { FETCH_DOCUMENT } from "@/queries/FetchDocument";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { CircularProgress } from "@mui/material";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { downloadUrl } from "@sequentech/ui-core";
import { GET_DOCUMENT } from "@/queries/GetDocument";
export var DownloadDocument = function (_a) {
    var _b, _c;
    var onDownload = _a.onDownload, fileName = _a.fileName, documentId = _a.documentId, electionEventId = _a.electionEventId, withProgress = _a.withProgress, onSucess = _a.onSucess;
    var _d = React.useState(false), downloaded = _d[0], setDownloaded = _d[1];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var tenantId = useTenantStore()[0];
    var _e = useQuery(GET_DOCUMENT, {
        variables: {
            id: documentId,
            tenantId: tenantId,
        },
        skip: !documentId || !tenantId || downloaded,
        pollInterval: globalSettings.QUERY_FAST_POLL_INTERVAL_MS,
        onError: function (error) {
            console.log("error downloading doc: ".concat(error.message));
        },
        onCompleted: function () {
            console.log("success downloading doc");
            harvestRefetch();
        },
    }), documents = _e.data, hasuraRefetch = _e.refetch;
    var _f = useQuery(FETCH_DOCUMENT, {
        variables: {
            electionEventId: electionEventId,
            documentId: documentId,
        },
        skip: !documentId || !tenantId || downloaded,
        pollInterval: globalSettings.QUERY_FAST_POLL_INTERVAL_MS,
        onCompleted: function () {
            console.log("completed fetching document");
            harvestRefetch();
        },
    }), loading = _f.loading, error = _f.error, data = _f.data, harvestRefetch = _f.refetch;
    var document = (_b = documents === null || documents === void 0 ? void 0 : documents.sequent_backend_document) === null || _b === void 0 ? void 0 : _b[0];
    console.log({ name: document === null || document === void 0 ? void 0 : document.name });
    useEffect(function () {
        var _a;
        if (!error && ((_a = data === null || data === void 0 ? void 0 : data.fetchDocument) === null || _a === void 0 ? void 0 : _a.url) && !downloaded && (fileName || document)) {
            onSucess && onSucess();
            console.log("setting downloaded true");
            setDownloaded(true);
            var name_1 = fileName || (document === null || document === void 0 ? void 0 : document.name) || "file";
            console.log("calling downloadUrl");
            downloadUrl(data.fetchDocument.url, name_1).then(function () { return onDownload(); });
        }
    }, [
        data,
        (_c = data === null || data === void 0 ? void 0 : data.fetchDocument) === null || _c === void 0 ? void 0 : _c.url,
        error,
        loading,
        document,
        fileName,
        downloaded,
        setDownloaded,
        onDownload,
        downloadUrl,
    ]);
    return withProgress ? _jsx(CircularProgress, {}) : _jsx(_Fragment, {});
};
